import CssBaseline from '@mui/material/CssBaseline'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import { defaultGateway } from './configuration/gateways'
import { AuthenticatedVulcan, VulcanAuthProvider } from './providers/VulcanAuthProvider'

const authGateway = defaultGateway()

const root = document.getElementById('root')
if (!root) throw new Error('The Vulcan root element was not found.')

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <VulcanAuthProvider gateway={authGateway}>
      <AuthenticatedVulcan>
        <CssBaseline />
        <App gateway={authGateway} />
      </AuthenticatedVulcan>
    </VulcanAuthProvider>
  </React.StrictMode>
)
